import { set } from 'lodash/fp';
import { endOfDay, startOfDay, subMonths } from 'date-fns';

import { SortDirection } from '../../utils/tableHelper';
import { REPORTS_MANAGER_TYPES, ReportsManagerStatuses } from '../../components/tables/reports-manager/consts';
import { getValidDateFromLocalStorage } from '../../utils/dateHelper';

export const REPORTS_MANAGER_LOADING = 'reports_manager_loading';
export const REPORTS_MANAGER_DATA = 'reports_manager_data';
export const REPORTS_MANAGER_SORT = 'reports_manager_sort';
export const REPORTS_MANAGER_UPDATE_TABLE = 'reports_manager_update_table';
export const REPORTS_MANAGER_SET_FILTER = 'reports_manager_set_filter';

const endDate = getValidDateFromLocalStorage('reportsManagerEndDate', endOfDay(new Date()));
const startDate = getValidDateFromLocalStorage('reportsManagerStartDate', startOfDay(subMonths(new Date(), 1)));

const initialState = {
  ui: {
    loading: false,
  },
  data: null,
  filters: {
    type: Object.values(REPORTS_MANAGER_TYPES),
    status: Object.keys(ReportsManagerStatuses),
    dates: {
      start: new Date(startDate),
      end: endDate ? new Date(endDate) : new Date(),
    },
  },
  table: {
    totalCount: 0,
    pagination: {
      page: 0,
      rowsPerPage: 50,
    },
    sort: {
      column: 'createdAt',
      direction: SortDirection.DESC,
    },
  },
};

const reportsManager = (state = initialState, action) => {
  switch (action.type) {
    case REPORTS_MANAGER_SET_FILTER: {
      const keys = Object.keys(action.payload);
      const isSameFilter = (key, value) => JSON.stringify(state.filters[key]) === JSON.stringify(value);
      const isSameFilters = keys.every((key) => isSameFilter(key, action.payload[key]));
      if (isSameFilters) return state;

      let finalState = state;
      keys.forEach((key) => {
        const value = action.payload[key];
        finalState = set(['filters', key], value, finalState);
      });
      finalState.table.pagination.page = 0;
      return finalState;
    }

    case REPORTS_MANAGER_LOADING:
      return set('ui.loading', action.payload.loading, state);

    case REPORTS_MANAGER_DATA: {
      const { data, totalCount } = action.payload;
      return {
        ...state,
        data,
        ui: {
          ...state.ui,
          loading: false,
        },
        table: {
          ...state.table,
          totalCount,
        },
      };
    }

    case REPORTS_MANAGER_UPDATE_TABLE: {
      return set(
        'table',
        {
          ...state.table,
          pagination: {
            ...state.table.pagination,
            ...action.payload.pagination,
          },
        },
        state,
      );
    }

    case REPORTS_MANAGER_SORT: {
      let { column, direction } = action.payload;

      return {
        ...state,
        table: {
          ...state.table,
          sort: { column, direction },
          pagination: set('page', 0, state.table.pagination),
        },
      };
    }

    default:
      return state;
  }
};

export default reportsManager;
